import { create } from 'zustand';

const useOpenCycles = create((set) => ({
  cycleIds: [],
  setCycleIds: (data) => set({ cycleIds: data })
}));

export default useOpenCycles;
